<template>
	<v-app>
		<v-content>
			<router-view />
		</v-content>
		<v-snackbar :timeout="alert.timeout" bottom right v-model="alert.show">{{ alert.text }}</v-snackbar>
	</v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "App",
	data: () => ({
		//
	}),
	computed: {
		...mapState({
			alert: "alert"
		})
	}
};
</script>
